import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tela-ajuda',
  templateUrl: './tela-ajuda.component.html',
  styleUrls: ['./tela-ajuda.component.scss']
})
export class TelaAjudaComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {

    var a = document.createElement('a');
    a.target = "_blank";
    a.href = 'https://syncode.movidesk.com';
    a.click();
    // Notification.requestPermission();

    // var notification = new Notification("Autorização de notificações", {
    //   icon: 'https://www.unifar.com.br/wp-content/uploads/2019/06/Logo-Unifar-Vazado_02.jpg'
    // });
    // setTimeout(() => {
    //   notification.close();
    // }, 2000);

    // window.scrollTo(0, 0)
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0)
  }


}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-ajuda/tela-ajuda.component.ts